// Pasos del embudo de las membresías que App no podía contar con
// logFreemiumMetric (auditoría de conversión del 25-oct-2026).
//
// Se escriben en la MISMA serie que ya usan Planes, la hoja del límite y el
// checkout: tabla `metrics`, pae_type 'rapido' y evento `freemium_<paso>:<detalle>`
// (logFreemiumMetric en App.jsx). Así "Planes abierto", "checkout iniciado" y
// "prueba iniciada" siguen siendo los mismos eventos de siempre y aquí solo se
// suman los pasos que faltaban, sin duplicar ninguno:
//   - enlace_planes:<origen>_<producto>  llegó a la app por un enlace
//     `?planes=1` (el botón de /precios o un correo), con o sin sesión.
//   - planes_abierto:enlace  ese enlace abrió Planes (después del login, si
//     hacía falta). Es el mismo evento que abrirPlanes, con su propio origen.
//   - pago_retorno:<estado>  volvió de Flow: ok, pendiente, tarjeta (no se
//     registró la tarjeta, nada se cobró) o error.
//   - pago_activo:<producto>  la app confirmó la membresía activa al volver.
// El registro de la tarjeta y la activación también quedan en el servidor, en
// `subscriptions` (consultas en docs/conversion-membresias-2026-10-25.md).
//
// Catálogo cerrado: el paso es uno de estos y el detalle se reduce a
// [a-z0-9_]. Jamás texto de la persona. Necesita la sesión para el user_id;
// sin ella va anónimo (la política de `metrics` acepta user_id nulo).

import { supabase } from './supabase';
import { registrarMetrica } from './metrics';

export const PASOS_EMBUDO = Object.freeze(['enlace_planes', 'planes_abierto', 'pago_retorno', 'pago_activo']);

// La misma limpieza de toMetricToken en App.jsx.
export function tokenMetrica(valor = '') {
  return String(valor || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'unknown';
}

export function eventoEmbudo(paso, detalle = null) {
  if (!PASOS_EMBUDO.includes(paso)) return null;
  return detalle ? `freemium_${paso}:${tokenMetrica(detalle)}` : `freemium_${paso}`;
}

export async function registrarEmbudo(paso, detalle = null) {
  const evento = eventoEmbudo(paso, detalle);
  if (!evento) return;
  let userId = null;
  try {
    const { data } = await supabase.auth.getSession();
    userId = data?.session?.user?.id || null;
  } catch { /* sin sesión legible: va anónimo */ }
  try { await registrarMetrica(userId, 'rapido', evento); } catch { /* telemetría best-effort */ }
}
